import {put} from '@redux-saga/core/effects';
const store = {
};

const reducer ={
    "ASN_FAILED":(payload)=>{
        const error = payload.value || "asn_failed";
        put({type:"SAGA_SESSION_CLEAR"});
        put({type:"SET_ERROR",error});
        console.log("ASN_FAILED",error);
        return store;
    }
};

export default {
    store:store,
    reducer:reducer
}
